import React from "react";
import Question from "../Global/Question";

const Priorities = (props) => {
  return <Question {...props} />;
};

export default Priorities;
